<script lang="ts">
  import { KpiCard, currencyPHP } from '@epitome-analytics/dashboard-kit';
  import { store } from '../lib/stores.svelte.js';
  import { fetchKpiTotals, type KpiTotals } from '../lib/queries.js';
  import { fmtShare, fmtInt } from '../lib/format.js';

  let totals = $state<KpiTotals | null>(null);
  let loading = $state(true);
  let error   = $state<string | null>(null);

  $effect(() => {
    void store.period; void store.principal; void store.productType; void store.brand; void store.sku_id;
    if (!store.period) return;
    loading = true; error = null;
    fetchKpiTotals(store.period)
      .then((t) => { totals = t; loading = false; })
      .catch((e) => { error = (e as Error).message; loading = false; });
  });
</script>

<section class="row">
  {#if error}
    <div class="banner">{error}</div>
  {:else if loading || !totals}
    <div class="banner muted">Loading totals…</div>
  {:else}
    <KpiCard eyebrow="MY GMV"       label="8-week revenue"          value={currencyPHP.formatPHPShort(totals.my_gmv)} />
    <KpiCard eyebrow="CATEGORY"     label="Total category GMV"      value={currencyPHP.formatPHPShort(totals.cat_gmv)} />
    <KpiCard eyebrow="SIZE OF PRIZE" label="Untapped revenue"        value={currencyPHP.formatPHPShort(totals.sop)} />
    <KpiCard eyebrow="MY SHARE"     label="Of category"             value={fmtShare(totals.share)} />
    <KpiCard eyebrow="COVERAGE"     label="Active SKU-city rows"    value={fmtInt(totals.cities)} />
  {/if}
</section>

<style>
  .row {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: var(--space-lg);
  }
  .banner {
    grid-column: 1 / -1;
    padding: var(--space-md) var(--space-lg);
    border-radius: var(--radius-md);
    background: var(--color-negative-bg);
    color: var(--color-negative);
    font-family: var(--font-ui);
    font-size: var(--text-sm);
  }
  .banner.muted { background: var(--color-info-bg); color: var(--color-info); }
</style>
